<div [id]="'gauge-' + chartId" [ngClass]="chartClass"></div>
